import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { MovementPatternRepoImpl } from "domain/repository/MovementPattern/MovementPatternRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { useMovementPatternTracked } from "presentation/store/MovementPattern/MovementPatternProvider";
import { MovementPatternVM } from "presentation/viewModel/MovementPattern/MovementPatternVM";
import { useMemo } from "react";

export const useMovementPatternVM = () => {
    const [, setMovementPatternState] = useMovementPatternTracked();
    const movementPatternVM = useMemo(() =>
        MovementPatternVM({
            dispatch: [setMovementPatternState],
            movementPatternRepo: MovementPatternRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
        }), [setMovementPatternState])

    return movementPatternVM
}